export const accommodationRoutes = {
  create: [],
  view: [
    {
      path: 'accommodation',
      title: `trip accommodation`,
      loadComponent: () =>
        import('./pages/accommodation-section/accommodation-section.page').then(
          (m) => m.AccommodationSectionPage,
        ),
    },
  ],
};
